import styled from 'styled-components';

export const Container = styled.div`
  &.group-wrapper {
    display: flex;
    flex-direction: column;
    gap: 15px;

    width: 100%;
    min-height: 290px;

    .button {
      margin-top: auto;
    }

    animation: entering 0.5s ease-in;
  }
`;

export const ReadPolicy = styled.div`
  position: relative;
  display: flex;

  font-size: 12px;
  color: #fff;

  margin: 0 auto;
  padding-right: 25px;

  .policy__checkbox-label {
    display: block;
    position: relative;
    padding-left: 20px;
    cursor: pointer;
    font-size: 14px;
    user-select: none;
    text-transform: none;

    input[type='checkbox'] {
      display: none;
    }

    input:checked ~ span {
      border: 2px solid var(--blue12);
      color: var(--blue12);
      padding: 1px 0;
    }

    span {
      width: 14px;
      height: 14px;
      display: block;
      position: absolute;
      top: 0;
      left: 0;

      font-size: 10.9px;
      color: #fff;
      font-weight: 700;
      text-align: center;

      border: 2px solid var(--blue12);
      border-radius: 3px;
      background-color: #fff;
    }
  }

  .policy__checkbox-label_text {
    margin-left: 85px;
  }

  .policy__read-terms {
    position: absolute;
    left: 20px;

    font-size: 14px;
    color: var(--blue12);
    cursor: pointer;
  }

  &.modal {
    margin-top: 15px;
    .modal__policy__checkbox-label_text {
      color: #727272;
      padding: 0;
    }

    input:checked ~ span {
      border: 2px solid var(--blue12);
      color: #fff;
      background-color: var(--blue12);
    }

    span {
      background-color: #fff;
      transition: all 0.2s;

      padding: 1px 0;
    }
  }

  @media (max-width: 400px) {
    margin: 5px auto;
    padding-right: 0;
  }
`;

export const Terms = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  max-width: 450px;
  padding: 0 15px;

  .terms__title {
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 1.4rem;
    color: var(--blue12);

    width: 100%;
    max-width: 450px;
    height: 60px;

    box-shadow: 0 3px 6px rgb(0 0 0 /16%);

    border-radius: 7px;
  }

  .terms__content {
    color: #727272;
    white-space: pre-line;
  }
`;
